import React from "react";
import styled from "styled-components/macro";
import { Trans } from "react-i18next";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import { Fade } from "@mui/material";
import { Portal } from "@mui/base";
import { devicePaddings } from "../../tools/device";
import { useGetState } from "components/ReduxProvider";

const { top } = devicePaddings();

const Wrap = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.duo.maxWidth.narrow};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
`;
const Bubble = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  max-width: calc(100% - 20px);
  top: ${top + 53}px;
  right: 8px;
  padding: 8px 14px;
  background: ${({ theme }) => theme.duo.color.lightBlue};
  border-radius: 8px;
  color: white;
  z-index: 760; /* highter than cards in Picker, longTouchHint and Backdrop */
  font-size: ${({ theme }) => theme.duo.fontSize.small};
  line-height: 1.4em;
  text-align: right;
  box-shadow: 1px 1px 4px #0003;
`;
const SArrowDropUpIcon = styled(ArrowDropUpIcon)`
  position: absolute;
  right: 7px;
  top: -17px;
  font-size: 30px;
  color: ${({ theme }) => theme.duo.color.lightBlue};
`;
const STouchAppIconRight = styled(TouchAppIcon)`
  /* prettier-ignore */
  @keyframes swipingRight {
    0%, 10% { left: 0;  transform: rotate(-20deg);}
    50%, 100% { left: 10px;  transform: rotate(20deg); }
    10%, 90% { opacity: 1; }
    0%, 100% { opacity: 0.3; }
  }
  position: relative;
  animation: swipingRight 2s ease-in-out infinite;
  margin-right: 10px;
`;
const STouchAppIconLeft = styled(TouchAppIcon)`
  /* prettier-ignore */
  @keyframes swipingLeft {
    0%, 10% { right: -10px;  transform: rotate(20deg);}
    50%, 100% { right: 0;  transform: rotate(-20deg); }
    10%, 90% { opacity: 1; }
    0%, 100% { opacity: 0.3; }
  }
  position: relative;
  animation: swipingLeft 2s ease-in-out infinite;
  margin-right: 10px;
`;

type Props = { onClick?: VoidFunction };

const FireWarning: React.FC<Props> = ({ onClick }) => {
  const xp = useGetState("xp");

  return (
    <Portal>
      <Wrap>
        <Fade in={xp.warn === "tooManyLeft"} timeout={1000}>
          <Bubble onClick={onClick}>
            <SArrowDropUpIcon />
            <STouchAppIconRight />
            <Trans>Swipe right if you are able to guess the other side already.</Trans>
          </Bubble>
        </Fade>

        <Fade in={xp.warn === "tooManyRight"} timeout={1000}>
          <Bubble onClick={onClick}>
            <SArrowDropUpIcon />
            <STouchAppIconLeft />
            <Trans>Swipe left if you are not able to guess the other side.</Trans>
          </Bubble>
        </Fade>
      </Wrap>
    </Portal>
  );
};

export default FireWarning;
